import API from "../api";
import { ServiceProps } from "../types";

import { Base } from "./_base";

const BaseService = <T extends any, R extends any = T>({ endpoint }: ServiceProps): Base<T, R> => {
  return {
    async getByFilter(options) {
      return await API.get(`/${endpoint}/get-by-filter`, { params: options });
    },
    async getById(id: number, options) {
      return await API.get(`/${endpoint}/${id}`, { params: options });
    },
    async count(options) {
      return await API.get(`${endpoint}/count`, { params: options });
    },
    async getAll(options) {
      return await API.get(`${endpoint}`, { params: options });
    },
    async getAndCountAll(options) {
      return await API.get(`/${endpoint}/related`, { params: options });
    },
    async getAllNetwork(options) {
      return await API.get(`/${endpoint}/network`, { params: options });
    },
    async create(data) {
      return await API.post(`${endpoint}`, data);
    },
    async createList(data) {
      return await API.post(`${endpoint}/list`, data);
    },
    async update(id, data) {
      return await API.put(`${endpoint}/${id}`, data);
    },
    async updateList(data) {
      return await API.put(`${endpoint}/list`, data);
    },
    async delete(id: number, options) {
      return await API.delete(`/${endpoint}/${id}`, { params: options });
    },
    async deleteList(data) {
      return await API.put(`/${endpoint}/delete/list`, data);
    },
  };
};

export default BaseService;
